module.exports = __webpack_public_path__ + "ploni-aaa-300.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-300.otf
// module id = 1197
// module chunks = 10